<div class="enrollment-confirmation-page">
    <div class="content">
        <div class="portalLogo"></div>
        <h2>Congratulations!</h2>
        <p>You are enrolled in the Amazon AFP Insurance Program.With this program you have access to world class
            protection. To access detail regarding your coverage, ID Cards and other data, click
            <a [routerLink]="['/coverage']">here</a>. Be sure to save your Login information so that you may access it whenever needed. We look forward to your
            success!</p>
        <button [routerLink]="['/coverage']" class="primary-button">
            View Amazon AFP Page
        </button>
    </div>
</div>